export default "__VITE_ASSET__b5513292__"